import React, { useEffect, useRef, useState } from 'react';
import { DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import { FaHeadset } from 'react-icons/fa';
import SelectRamalSoftphone from './selectRamal';
import DialpadWebRTC from './dialpad';
import userAgentSingleton from './userAgent/userAgentSingleton';
import { toast } from 'react-toastify';
import CryptoJS from 'crypto-js';
import { apiUc } from '../../../../http';

const ModalSoftphone = ({
  updateCallState,
  callState,
  callStateStatus,
  callStateColor
}) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [extensions, setExtensions] = useState(undefined);

  const [receivedInvitation, setReceivedInvitation] = useState(null);
  const elementoLocal = useRef();

  const verifySoftphoneConnection = (allowedExtensions) => {
    if (
      localStorage.getItem('webrtc_auto_login') === 'true' &&
      allowedExtensions?.length == 1 &&
      userAgentSingleton.ramal == null
    ) {
      const ramal = allowedExtensions[0];

      updateRamal({
        number: ramal.extension_number,
        secret: ramal.secret
      });
    } else {
      const softphoneRamalSessionString = localStorage.getItem(
        'softphone_ramal_session'
      );

      const ramalSessionNumber =
        softphoneRamalSessionString == undefined
          ? undefined
          : Number(softphoneRamalSessionString);

      if (ramalSessionNumber == undefined && userAgentSingleton.ramal != null) {
        updateRamal(undefined);
      } else if (
        localStorage.getItem('softphone_user_session') ===
        localStorage.getItem('login')
      ) {
        const allowedRamalFromSession = allowedExtensions?.filter(
          (extension) => extension.extension_number == ramalSessionNumber
        );

        if (
          allowedRamalFromSession?.length === 1 &&
          userAgentSingleton.ramal == null
        ) {
          const ramal = allowedRamalFromSession[0];
          updateRamal({
            number: ramal.extension_number,
            secret: ramal.secret
          });
        }
      }
    }
  };

  useEffect(() => {
    if (extensions == undefined && userAgentSingleton.ramal == undefined) {
      apiUc
        .get('/api/ramais/webrtc', {
          headers: { login: localStorage.getItem('login') }
        })
        .then(({ data }) => {
          const allowedExtensions = [];

          data.data.forEach((extension) => {
            if (extension.transport === 'WSS') {
              const secret = CryptoJS.AES.decrypt(
                extension.secret,
                process.env.REACT_APP_EXTENSION_SECRET_KEY
              );

              const decryptedSecret = secret.toString(CryptoJS.enc.Utf8);

              allowedExtensions.push({
                extension_number: extension.extension_number,
                identifier: extension.identifier,
                transport: extension.transport,
                secret: decryptedSecret
              });
            }
          });
          setExtensions([...allowedExtensions]);

          verifySoftphoneConnection(allowedExtensions);
          setInterval(() => {
            verifySoftphoneConnection(allowedExtensions);
          }, 5000);
        })
        .catch(() => {
          toast.error('Não foi possível carregar os ramais', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleModal = () => setOpen(!open);

  const updateRamal = async (ramal) => {
    setIsLoading(true);
    if (ramal == undefined) {
      await userAgentSingleton.disconnect();
    } else {
      console.log(ramal);
      await userAgentSingleton.connect(
        ramal.number,
        ramal.secret,
        setReceivedInvitation,
        updateCallState,
        setOpen,
        onDisconnect
      );
    }
    setIsLoading(false);
  };

  const onDisconnect = async () => {
    await updateRamal(undefined);
  };

  let componentToRender = (
    <SelectRamalSoftphone
      onSelect={updateRamal}
      isLoading={isLoading}
      extensions={extensions}
    ></SelectRamalSoftphone>
  );
  if (userAgentSingleton.ramal && !isLoading) {
    componentToRender = (
      <DialpadWebRTC
        ramal={userAgentSingleton.ramal}
        onDisconnect={onDisconnect}
        callState={callState}
        callStateColor={callStateColor}
        callStateStatus={callStateStatus}
        receivedInvitation={receivedInvitation}
        setOpen={setOpen}
      ></DialpadWebRTC>
    );
  }

  return (extensions ?? []).length == 0 ? null : (
    <Dropdown nav isOpen={open} toggle={toggleModal}>
      <DropdownToggle
        className="nav-link"
        tag="a"
        style={{ cursor: 'pointer' }}
      >
        <audio ref={elementoLocal} id="mediaElement">
          <p>O seu navegador não suporta áudio</p>
        </audio>
        <div
          style={
            userAgentSingleton.ramal != undefined && callStateStatus != null
              ? {
                  border: '1px solid white',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '6px 10px 6px 10px'
                }
              : undefined
          }
        >
          <FaHeadset
            strokeWidth={2}
            style={{
              cursor: 'pointer',
              color: 'white',
              borderRadius: '5%',
              fontWeight: 'bold',
              fontSize: '1.4rem',
              fill: '#FFF'
            }}
          />
          {userAgentSingleton.ramal != undefined && callStateStatus != null ? (
            <div
              className="statusRow"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 10px 0 10px'
              }}
            >
              <div
                style={{
                  background: callStateColor,
                  border: '1px solid white',
                  width: '12px',
                  height: '12px',
                  borderRadius: '17px',
                  marginRight: '4px'
                }}
              ></div>
              <p style={{ color: 'white', margin: 0 }}>{`${
                callStateStatus ?? 'Desconectado'
              }`}</p>
            </div>
          ) : null}
        </div>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-xl py-0 overflow-y-visible" right>
        {componentToRender}
      </DropdownMenu>
    </Dropdown>
  );
};

export default ModalSoftphone;
